import { mapValues, filter } from "lodash-es"

export default () => ({
  itemsUpdated({ items }) {
    return mapValues(items, configItems => {
      return filter(configItems, { _updated: true })
    })
  }
})
